import { combineReducers } from 'redux'
import sessionReducer from './session'
import introQuestions from './introQuestions'
import currentQuestionIndex from './currentIntroQuestion'
import prevQuestionIndex from './prevIntroQuestion'
import plantList from './plantList'
import deviceList from './deviceList'
import devices from './devices'
import plants from './plants'
import search from './search'
import settings from './settings'
import favoritePlants from './favoritePlants'
import similarPlants from './similarPlants'
import classifier from './classifier'
import pageHistory from './pageHistory'
import tensorflowModel from './tensorflowModels'
import mode from './modes'

const rootReducer = combineReducers({
    classifier,
    currentQuestionIndex,
    deviceList,
    devices,
    favoritePlants,
    introQuestions,
    mode,
    pageHistory,
    plantList,
    plants,
    prevQuestionIndex,
    search,
    sessionState: sessionReducer,
    settings,
    similarPlants,
    tensorflowModel,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js